import React, { useEffect, useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { FaEye, FaEdit, FaTrash, FaEyeSlash, FaExchangeAlt, FaArrowLeft } from "react-icons/fa";
import {
    startAiCall,
    getAiCallHistory,
} from "../../../redux/services/Ai Services/Ai.Services";
import { successToast, errorToast } from "../../../Utils/toast";
import { getAdminData } from "../../../Utils/role";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Pagination from '../../../common/Pagination';
function DemoAi() {
    const navigate = useNavigate();
    const adminData = getAdminData();

    const [formData, setFormData] = useState({
        mobile: "",
        name: adminData.name,
        lead_id: "LEAD-001",
    });

    const [callHistory, setCallHistory] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [initialLoading, setInitialLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [limit, setLimit] = useState(100);
    const [loading, setLoading] = useState(false);
    const [calling, setCalling] = useState(false);

    const fetchCallHistory = async (pageNo = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }

            // const payload = {
            //     filter: "all",
            // };
            const payload = {
                page: pageNo,
                per_page: limit,
            };
            const response = await getAiCallHistory(payload);
            // successToast(response.message)
            setCallHistory(response?.data?.history || []);
            setTotalPages(response?.last_page || 1);
            setPage(response?.current_page || 1);

        } catch (error) {
            console.error("AI Call History Error:", error);
            setCallHistory([]);
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };

    // useEffect(() => {
    //     fetchCallHistory();
    // }, []);

    useEffect(() => {
        fetchCallHistory(1, true);
    }, [limit]);

    const handlePageChange = (newPage) => {
        if (
            newPage >= 1 &&
            newPage <= totalPages &&
            !tableLoading
        ) {
            setPage(newPage);
            fetchCallHistory(newPage, false);
        }
    };
    const validateMobile = (mobile) => {
        if (!mobile) {
            return "Mobile number is required";
        }

        if (mobile.length !== 10) {
            return "Please enter a valid 10-digit mobile number";
        }

        if (!/^[6-9]\d{9}$/.test(mobile)) {
            return "Please enter a valid Indian mobile number";
        }

        return null;
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleCalling = async (e) => {
    e.preventDefault();
    const validationError = validateMobile(formData.mobile);

    if (validationError) {
        errorToast(validationError);
        return;
    }

    try {
        setCalling(true);

        const payload = {
            phone: formData.mobile,
            name: formData.name,
            lead_id: formData.lead_id,
        };

        const response = await startAiCall(payload);

        // Treat as success only if BOTH top-level and nested success are true
        const isSuccess =
            response?.success === true &&
            response?.api_response?.success !== false;

        // Pick the most specific message available from the API
        const apiMessage =
            response?.api_response?.detail ||
            response?.api_response?.message ||
            response?.message ||
            "No message returned from API";

        if (isSuccess) {
            successToast(apiMessage);

            setFormData((prev) => ({ ...prev, mobile: "" }));
            fetchCallHistory();
        } else {
            errorToast(apiMessage);
        }
    } catch (error) {
        console.error("AI Calling Error:", error);

        // Show whatever the API error response contains
        const errData = error?.response?.data;

        const errMessage =
            errData?.api_response?.detail ||
            errData?.api_response?.message ||
            errData?.message ||
            error?.message ||
            "AI calling failed";

        errorToast(errMessage);
    } finally {
        setCalling(false);
    }
};
    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
                <div className="title_member">
                    <h4>Demo AI</h4>
                </div>
            </div>

            <div className="main_page">
                <div className="st-wrapper-card mb-4">
                    {/* <div className="p-3">
                        <h5 className="mb-3">AI Calling</h5>
                        <form onSubmit={handleCalling}>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">
                                        Mobile Number
                                    </label>

                                    <input
                                        type="tel"
                                        name="mobile"
                                        className="form-control"
                                        placeholder="Enter mobile number"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end">
                                <button
                                    type="submit"
                                    className="add-btn"
                                    disabled={calling}
                                >
                                    <FaPhoneAlt className="me-1" />

                                    {calling
                                        ? "Calling..."
                                        : "Calling"}
                                </button>
                            </div>
                        </form>
                    </div> */}

                    <form className="ai-calling-form">
                        <div className="form-group">
                            <label className="form-label">Mobile Number</label>
                            <div className="ai-calling-inline">
                                <input
                                    type="text"
                                    name="mobile"
                                    className="form-control"
                                    placeholder="Enter mobile number"
                                    value={formData.mobile}
                                    maxLength={10}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");

                                        setFormData((prev) => ({
                                            ...prev,
                                            mobile: value,
                                        }));
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={handleCalling}
                                    className="ai-calling-btn"
                                    disabled={calling || formData.mobile.length !== 10}
                                >
                                    <FaPhoneAlt className="me-2" />
                                    {calling ? "Calling..." : "Start Call"}
                                </button>
                            </div>
                            <small className="ai-calling-hint">Enter a valid 10-digit mobile number</small>
                        </div>
                    </form>
                </div>
                <div className="st-wrapper-card">
                    <div className="p-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="mb-0">
                                Call History
                            </h5>
                        </div>
                        <div className="st-table-responsive">
                            <table className="table st-custom-table align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th>Sr.No</th>
                                        {/* <th>Name</th> */}
                                        <th>Mobile</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Duration</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                Loading...
                                            </td>
                                        </tr>
                                    ) : callHistory.length > 0 ? (
                                        callHistory.map((item, index) => (
                                            <tr
                                                key={item.lead_id || index}
                                            >
                                                <td>{index + 1}</td>
                                                {/* <td>{item.name || "-"}</td> */}
                                                <td>{item?.mobile_no || "-"}</td>
                                                <td>{item.called_at ? item.called_at.split(" ")[0] : "-"} </td>
                                                <td>{item.called_at ? item.called_at.split(" ")[1] : "-"} </td>
                                                <td>{item.duration || "0s"}</td>
                                                <td>
                                                    <span
                                                        className={`crm-status-badge crm-status-${item.status
                                                            ? item.status.toLowerCase()
                                                            : "default"
                                                            }`}
                                                    >
                                                        {item.status
                                                            ? item.status.replaceAll("_", " ")
                                                            : "-"}
                                                    </span>
                                                </td>

                                                <td >
                                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                                        <button
                                                            className="st-action-btn st-view-btn"
                                                            // onClick={() =>
                                                            //     navigate(`/view-call-detail/${item.phone}`)
                                                            // }
                                                            onClick={() => {
                                                                const cleanPhone = item.mobile_no.replace(/\D/g, "").slice(-10);
                                                                navigate(`/view-call-detail/${cleanPhone}`);
                                                            }}
                                                        >
                                                            <FaEye />
                                                        </button>
                                                        {/* <button
                                                                         className="st-action-btn st-edit-btn"
                                                                         onClick={() =>
                                                                           navigate(`/update-user/${item.id}`)
                                                                         }
                                                                       >
                                                                         <FaEdit />
                                                                       </button>
                                                                       <button
                                                                         className="st-action-btn st-delete-btn"
                                                                         onClick={() =>
                                                                           dispatch(
                                                                             openProductModal({
                                                                               type: "delete-user",
                                                                               title: "Delete User",
                                                                               data: {
                                                                                 id: item.id,
                                                                                 deleteFunction: deleteUser,
                                                                                 refreshData: fetchUserList,
                                                                               },
                                                                             })
                                                                           )
                                                                         }
                                                                       >
                                                                         <FaTrash />
                                                                       </button> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                No Call History Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                            {totalPages > 1 && (
                                <div className="d-flex justify-content-end mb-3">
                                    <Pagination
                                        page={page}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default DemoAi;